import { render, staticRenderFns } from "./TenderCardOffersBadge.vue?vue&type=template&id=97d103fa&"
import script from "./TenderCardOffersBadge.vue?vue&type=script&lang=js&"
export * from "./TenderCardOffersBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports